const themeColors = {
    primary: {
        main: '#5124A6',
    },
    secondary: {
        main: '#49DEFF',
    },
    common: {
        grey: '#9C9AA7',
        black1e: '#1E1E1E',
        link: '#548CFF',
    },
};

export const themeConfig = {
    palette: themeColors,
    typography: {
        h1: {
            color: themeColors.common.black1e,
            fontSize: 48,
            fontWeight: 700,
            '@media (max-width:767px)': {
                fontSize: 30,
            },
        },
        h2: {
            color: themeColors.common.black1e,
            fontSize: 30,
            fontWeight: 700,
            '@media (max-width:767px)': {
                fontSize: 20,
            },
        },
        h3: {
            color: themeColors.common.black1e,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: 700,
            '@media (max-width:767px)': {
                fontSize: 18,
            },
        },
        h5: {
            color: themeColors.common.black1e,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: 'Poppins',
            '@media (max-width:767px)': {
                fontSize: 12,
            },
        },
        subtitle1: {
            fontSize: 18,
            fontWeight: 700,
            color: themeColors.common.black1e,
            '@media (max-width:767px)': {
                fontSize: 16,
                lineHeight: '22px',
            },
        },
        subtitle2: {
            fontSize: 18,
            fontWeight: 500,
            color: themeColors.common.black1e,
            '@media (max-width:767px)': {
                fontSize: 16,
            },
        },
        body1: {
            fontSize: 16,
            color: themeColors.common.black1e,
            '@media (max-width:767px)': {
                fontSize: 14,
            },
        },
        body2: {
            fontSize: 14,
            lineHeight: '21px',
            color: themeColors.common.black1e,
            '@media (max-width:767px)': {
                fontSize: 12,
                lineHeight: '18px',
            },
        },
        body3: {
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'Poppins',
            color: themeColors.common.black1e,
            '@media (max-width:767px)': {
                fontSize: 12,
            },
        },
        body4: {
            fontSize: 16,
            color: themeColors.primary.main,
            fontFamily: 'Poppins',
            fontWeight: 700,
            '@media (max-width:767px)': {
                fontSize: 14,
            },
        },
        button_tertiary: {
            fontSize: 16,
            color: themeColors.primary.main,
            fontWeight: 600,
            '@media (max-width:767px)': {
                fontSize: 14,
            },
        },
        link: {
            fontSize: 14,
            color: themeColors.common.link,
            fontWeight: 700,
            fontFamily: 'Poppins',
            '@media (max-width:767px)': {
                fontSize: 14,
            },
        },
        caption: {
            fontSize: 12,
            fontFamily: 'Poppins',
            fontWeight: 500,
            color: themeColors.common.black1e,
        },
        fontFamily: 'Poppins',
        bodyMenu: {
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'Poppins',
            color: themeColors.common.white,
            '@media (max-width:767px)': {
                fontSize: 12,
            },
        },
        shareTitle: {
            color: '#FFFFFF',
            fontSize: 12,
            fontWeight: 600,
        },
        shareLink: {
            color: '#999999',
            fontSize: 10,
            fontWeight: 600,
        },
        body11: {
            fontSize: 14,
            fontWeight: 500,
            fontFamily: 'Poppins',
            color: themeColors.common.black1e,
            '@media (max-width:767px)': {
                fontSize: 12,
            },
        },
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                },
            },
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        fontWeight: 600,
                        textTransform: 'none',

                        '&.Mui-disabled': {
                            color: '#CCC9D1',
                            backgroundColor: '#F6F6F6',
                        },
                    },
                },
                {
                    props: { variant: 'contained' },
                    style: {
                        fontWeight: 600,
                        textTransform: 'none',
                    },
                },
            ],
        },
    },
};

export const border = { border: '1px solid rgba(0, 0, 0, 0.2)' };
